import SuiButton from './components/basic/SuiButton.vue'
import SuiButtonGroup from './components/basic/SuiButtonGroup.vue'
import SuiField from './components/basic/SuiField.vue'

import SuiInput from './components/form/SuiInput.vue'
import SuiSelect from './components/form/SuiSelect.vue'
import SuiMutilSelect from './components/form/SuiMutilSelect.vue'
import SuiOption from './components/form/SuiOption.vue'
import SuiCascader from './components/form/SuiCascader.vue'
import SuiDate from './components/form/SuiDate.vue'

import SuiForm from './components/data/SuiForm.vue'
import SuiFormGroup from './components/data/SuiFormGroup.vue'
import SuiFormItem from './components/data/SuiFormItem.vue'

import SuiProp from './components/other/SuiProp.vue'
import SuiFormPage from './components/other/SuiFormPage.vue'

import SuiTooltip from './components/func/SuiTooltip.vue'

import businessComponents from './components/business'

import method from './components/vue/method'

export const components = {
  SuiButton,
  SuiButtonGroup,
  SuiField,

  SuiInput,
  SuiMutilSelect,
  SuiSelect,
  SuiOption,
  SuiCascader,
  SuiDate,

  SuiForm,
  SuiFormGroup,
  SuiFormItem,

  SuiProp,
  SuiFormPage,

  SuiTooltip,

  ...businessComponents
}

const version = '__VERSION__'

const install = function (Vue, opts = {}) {
  opts.elementConfig = Object.assign({ $mode: 'easy', easyInputWidth: 230, tightInputWidth: 200 }, opts.elementConfig || {})
  opts = Object.assign({ size: 'small' }, opts)

  Object.keys(components).forEach((key) => {
    /* Vue.component("kui" + key, components[key]); */
    Vue.component(components[key].name, components[key])
  })

  // 宽松/紧凑 模式；easy：宽松 tight：紧凑
  Vue.prototype.$ELEMENT = {
    size: opts.size || '',
    zIndex: opts.zIndex || 2000,
    inputWidth: {
      easy: Number(opts.elementConfig.easyInputWidth) || 230,
      tight: Number(opts.elementConfig.tightInputWidth) || 200
    }
  }
  if (!['easy', 'tight'].includes(opts.elementConfig.$mode)) {
    opts.elementConfig.$mode = 'easy'
  }
  Vue.util.defineReactive(Vue.prototype.$ELEMENT, '$mode', opts.elementConfig.$mode)

  Vue.use(method)
}

const plugin = {
  install,
  version
}

/* istanbul ignore if */
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

export default plugin



// WEBPACK FOOTER //
// ./src/components/SimbartUI/index.js